function companiesAnimations() {
    // Clean up previous timelines
    if (window._companyTimelines) {
        window._companyTimelines.forEach(tl => tl.kill());
    }
    window._companyTimelines = [];

    // Helper: duplicate image if only one present
    function ensureTwoImages($wrapper, imgClass) {
        let $pictures = $wrapper.find('picture');
        if ($pictures.length === 1) {
            const $clone = $pictures.eq(0).clone();
            $clone.addClass('js-clone');
            $wrapper.append($clone);
            $pictures = $wrapper.find('picture');
        }
        // Add animation classes to the img inside each picture
        $pictures.eq(0).find('img').addClass(imgClass + '--one');
        $pictures.eq(1).find('img').addClass(imgClass + '--two');
        // Return both images for GSAP
        return $wrapper.find('img');
    }

    // Vertical scrolling (normal direction)
    $('.scroll-top-to-bottom').each(function () {
        const $wrapper = $(this);
        const $imgs = ensureTwoImages($wrapper, 'vertical-img');
        if ($imgs.length < 2) return;

        const duration = 48;
        const tl = gsap.timeline({ repeat: -1, defaults: { ease: "linear" } });

        tl.set($imgs.eq(0), { y: '0%' });
        tl.set($imgs.eq(1), { y: '100%' });
        tl.to($imgs.eq(0), { y: '-100%', duration }, 'a');
        tl.to($imgs.eq(1), { y: '0%', duration }, 'a');

        window._companyTimelines.push(tl);
    });

    // Vertical scrolling (reverse direction)
    $('.scroll-top-to-bottom--reverse').each(function () {
        const $wrapper = $(this);
        const $imgs = ensureTwoImages($wrapper, 'vertical-img');
        if ($imgs.length < 2) return;

        const duration = 48;
        const tl = gsap.timeline({ repeat: -1, defaults: { ease: "linear" } });

        tl.set($imgs.eq(0), { y: '0%' });
        tl.set($imgs.eq(1), { y: '-100%' });
        tl.to($imgs.eq(0), { y: '100%', duration }, 'a');
        tl.to($imgs.eq(1), { y: '0%', duration }, 'a');

        window._companyTimelines.push(tl);
    });

    // Horizontal scrolling (normal direction)
    $('.scroll-left-right').each(function () {
        const $wrapper = $(this);
        const $imgs = ensureTwoImages($wrapper, 'horizontal-img');
        if ($imgs.length < 2) return;

        const duration = 35;
        const tl = gsap.timeline({ repeat: -1, defaults: { ease: "linear" } });

        tl.set($imgs.eq(0), { x: '0%' });
        tl.set($imgs.eq(1), { x: '100%' });
        tl.to($imgs.eq(0), { x: '-100%', duration }, 'a');
        tl.to($imgs.eq(1), { x: '0%', duration }, 'a');

        window._companyTimelines.push(tl);
    });

    // Horizontal scrolling (reverse direction)
    $('.scroll-left-right--reverse').each(function () {
        const $wrapper = $(this);
        const $imgs = ensureTwoImages($wrapper, 'horizontal-img');
        if ($imgs.length < 2) return;

        const duration = 35;
        const tl = gsap.timeline({ repeat: -1, defaults: { ease: "linear" } });

        tl.set($imgs.eq(0), { x: '0%' });
        tl.set($imgs.eq(1), { x: '-100%' });
        tl.to($imgs.eq(0), { x: '100%', duration }, 'a');
        tl.to($imgs.eq(1), { x: '0%', duration }, 'a');

        window._companyTimelines.push(tl);
    });
}

// Run on ready and resize
$(document).ready(function () {
    companiesAnimations();
});
$(window).on('resize', function () {
    // Remove any JS clones before re-initializing
    $('.js-clone').remove();
    companiesAnimations();
});